/* eslint-disable @typescript-eslint/no-namespace */
import { shaderMaterial } from '@react-three/drei';
import { extend, ReactThreeFiber } from '@react-three/fiber';
import { ShaderMaterial, VideoTexture, Texture } from 'three';

// type IShaderMaterial = ReactThreeFiber.MaterialNode<
// 	ShaderMaterial,
// 	typeof ShaderMaterial
// >

// interface IAlphaMaterial extends IShaderMaterial {
// 	packedTexture: Texture | VideoTexture;
// }

const vertexShader = `
varying vec2 alphaUv;
varying vec2 colorUv;
void main() {
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    colorUv = vec2(uv.x, uv.y * 0.5 + 0.5);
    alphaUv = vec2(uv.x, uv.y * 0.5);
}
`;

const fragmentShader = `
uniform sampler2D packedTexture;
uniform float opacity;
varying vec2 alphaUv;
varying vec2 colorUv;
void main() {
    vec4 color = texture2D(packedTexture, colorUv);
    color.a = texture2D(packedTexture, alphaUv).g * opacity;
    gl_FragColor = color;
}
`;

const _AlphaMaterial = shaderMaterial(
	{ packedTexture: new Texture() as Texture | VideoTexture, opacity: 1 },
	vertexShader,
	fragmentShader
);


export default extend(_AlphaMaterial);
